export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.permissions': 'Permissions',
  'menu.talent-review': 'Talent Review',
  'menu.talent-review.workbench': 'Workbench',
  'menu.talent-review.cycles': 'Cycle Management',
  'menu.talent-review.participants': 'Participant Review',
  'menu.talent-review.scoring': 'Scoring',
  'menu.talent-review.results': 'Result Review',
  'menu.talent-review.dashboard': 'Dashboard',
  'menu.talent-review.job-profiles': 'Job Profiles',
  'menu.talent-review.fit-analysis': 'Fit Analysis',
  'menu.talent-review.reports': 'Reports',
  'menu.talent-review.employee-detail': 'Employee Detail',
  'menu.talent.list': 'Talent Profiles',
  'menu.talent.detail': 'Talent Detail',
  'menu.review.grid': 'Talent Review',
  'menu.review.tasks': 'Review Tasks',
  'menu.review.tasks.detail': 'Review Task Execution',
  'menu.interview': 'Talent Interviews',
  'menu.interview.session': 'Interview Session',
  'menu.pool': 'Talent Pool',
  'menu.insights': 'Organization Insights',
  'menu.development.plan': 'Development Plan',
  'menu.succession': 'Succession Plan',
  'menu.settings.tags': 'Tag Settings',
  'menu.settings.model': 'Capability Model',
  'menu.settings.grid': 'Nine-Box Model',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
